const route = () => '/';

export default route;
